import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RouterPasseLivre } from './router';

@Injectable({
  providedIn: 'root'
})
export abstract class RouterExternalCrewService implements RouterPasseLivre {

  constructor(private router: Router) {}

  goHome(params: any): void {
    this.router.navigate(['/external-home', params]);
  }
}
